import { FC } from "react";

import { BaseColumnProps } from "../BaseColumnProps";
import { ColumnElementConstructor } from "../ColumnElementConstructor";
import { getFormattedValue } from "../helpers/getFormattedValue";
import { Custom } from "./Custom";

/**
 * The `Number` component properties.
 */

export interface NumberProps extends Omit<BaseColumnProps, "align"> {
  /**
   * The minimum number of raction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
   */
  readonly minimumFractionDigits?: number;

  /**
   * The maximum number of fraction digits to use The maximum number of fraction digits to use and possible values are from 0 to 100.
   */
  readonly maximumFractionDigits?: number;
}

/**
 * Column which displays formatted Number values.
 */
export const Number: FC<NumberProps> = (props) => {
  const { minimumFractionDigits, maximumFractionDigits } = props;

  return (
    <Custom {...props}>
      {(value) => {
        if (value === null) return "--";
        if (typeof value === "undefined") return "--";
        if (typeof value === "string") return getFormattedValue(value, minimumFractionDigits, maximumFractionDigits) || "--";
        if (typeof value === "number") return getFormattedValue(value.toString(), minimumFractionDigits, maximumFractionDigits);
      }}
    </Custom>
  );
};

(Number as ColumnElementConstructor<NumberProps>).className = "number";
(Number as ColumnElementConstructor<NumberProps>).headerAlignment = "right";
